<template><BusinessPage module-key="payments" /></template>
<script>import BusinessPage from '../common/BusinessPage.vue'; export default { name: 'PaymentsPage', components: { BusinessPage } }</script>
